



































































import { Component, Mixins, Watch, Prop, Model } from 'vue-property-decorator'
import GoodsSelect from '@/components/goods-select/index.vue'
import AbpBase from '@/lib/abpbase'
import CustomCategoryProductApi from '@/api/goods/customCategoryProduct/index'
import appconst from '@/lib/appconst'
@Component({
  components: {
    GoodsSelect
  }
})
export default class CustomCategoryProduct extends AbpBase {
  uploadUrl = ``
  templateUrl = `${appconst.remoteServiceBaseUrl}/api/productManagement/customCategoryProduct/templateFile`
  //   @Prop({ type: String, default: '' }) value!: any
  @Model('change', { type: String }) categoryId!: string
  pager = {
    pageSize: 10,
    pageIndex: 1,
    total: 0
  }
  keyWord = ''
  columns = [
    {
      title: '货号',
      key: 'productCode',
      width: 120
    },
    {
      title: '商品名称',
      key: 'productName'
    },
    {
      title: '操作',
      key: 'action',
      slot: 'action',
      width: 120
    }
  ]
  products = []

  uploadData = {
    CustomCategoryId: this.categoryId
  }
  mounted() {}
  @Watch('categoryId', { immediate: true })
  valueChange(value) {
    if (value) {
      this.uploadUrl = `${appconst.remoteServiceBaseUrl}/api/productManagement/customCategoryProduct/excel/upload?CustomCategoryId=${this.categoryId}`
      this.loadData(value)
    }
  }
  query() {
    this.loadData(this.categoryId)
  }
  uploadSuccess() {
    this.$Message.success('导入成功')
    this.loadData(this.categoryId)
  }
  downloadTemplate() {
    location.href = this.templateUrl
  }
  loadData(id) {
    CustomCategoryProductApi.getList(
      this.pager.pageSize,
      this.pager.pageIndex,
      id,
      this.keyWord
    ).then(res => {
      this.products = res.data.items
      this.pager.total = res.data.totalCount
    })
  }
  pageChange(pageIndex) {
    this.pager.pageIndex = pageIndex
    this.loadData(this.categoryId)
  }
  deleteItem(row) {
    CustomCategoryProductApi.deleteProduct([row.id]).then(res => {
      this.$Message.success('删除成功')
      this.loadData(this.categoryId)
    })
  }
  onChange(e) {
    if (e.length <= 0) {
      return
    }
    var data = e.map(t => {
      return {
        productId: t.id,
        pictureUrl: t.pictureUrl,
        productCode: t.code,
        productName: t.name,
        customCategoryId: this.categoryId
      }
    })
    CustomCategoryProductApi.addProducts(data).then(res => {
      this.$Message.success('添加成功')
      this.loadData(this.categoryId)
    })
  }
  get selectedItems() {
    return this.products.map(t => t.id)
  }
}
